import react from 'react';
import BasicChart from '../../components/general/LineChart';

const TextBox = props => {
  const { ercotPriceData, average5DayPrice, zipCode } = props;
  return (
    <div class="bg-gradient-to-b from-fadedYellow pt-24 pb-16 text-center">
      <div class="px-10">
        <h3 class="max-w-screen-lg tracking-wide mx-auto uppercase font-extrabold text-black sm:text-lg md:text-4xl">
          <span class="text-darkYellow"> Yippee! We serve your area. </span>You’re on your way to
          joining the Hybrid Power neighborhood.
        </h3>
        <div class="">
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <p class="tracking-widest font-bold mb-4 text-black pt-10 sm:text-lg md:text-xl sm:px-24">
              The Current Energy Price for{' '}
              <span class="text-darkYellow font-extrabold text-4xl "> {zipCode}</span>
            </p>
            <h1 class="bg-gradient-to-r from-red-500 to-yellow rounded-md mx-auto text-3xl tracking-widest font-extrabold text-white pt-4 pb-1 px-6 mb-14 sm:text-5xl">
              {average5DayPrice}/kWh
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextBox;
